export const serviceLogMatrixPath = {
  PULL_SERVICE_LOG: '/service_log_matrix/pull',
  RETRIEVE_BATCH: '/service_log_matrix/batch/retrieve',
  RETRIEVE_UB04_BATCH : '/ub04/batch/retrieve',
  PULL_UB04_SERVICE_LOG : '/ub04/pull',
};

export const momentaryToken = undefined;
